import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PainPoints() {
  const painPoints = ['Evita leer o practicar.', 'Se frustra cuando ve letras.', 'Confunde sonidos o palabras.', 'Las tareas terminan en tensión o llanto.', 'Probaste fichas, videos o ejercicios… pero nada parece funcionar.', 'Querés ayudarlo, pero nadie te explicó qué hacer ni en qué orden.'];
  return <section className="py-8 md:py-20 px-4 bg-gradient-to-br from-kid-purple/5 via-kid-pink/5 to-white relative overflow-hidden" data-id="element-268">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-269">
        <FadeIn data-id="element-270">
          <div className="text-center mb-6 md:mb-12" data-id="element-271">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-6" data-id="element-272">
              Si tu hijo se frustra cuando intenta leer, no estás solo.
            </h2>
            <div className="w-24 h-1 bg-gradient-to-r from-kid-purple to-kid-pink mx-auto rounded-full" data-id="element-273"></div>
            <p className="text-base md:text-lg text-gray-500 font-medium mt-4" data-id="element-274">
              Tal vez ya viste esto en casa:
            </p>
          </div>
        </FadeIn>

        <div className="w-full" data-id="element-275">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-5" data-id="element-276">
            {painPoints.map((point, idx) => <FadeIn key={idx} delay={idx * 0.08} data-id="element-277">
                <div className="flex items-start gap-3 md:gap-4 p-4 md:p-5 rounded-xl bg-white shadow-sm border border-gray-200 border-l-[5px] border-l-kid-rose h-full" data-id="element-278">
                  <XCircleIcon className="w-5 h-5 text-kid-rose flex-shrink-0 mt-0.5" data-id="element-279" />
                  <p className="text-gray-700 font-semibold text-sm md:text-base leading-snug md:leading-relaxed" data-id="element-280">
                    {point}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.5} data-id="element-281">
          <div className="text-center mt-8 md:mt-12" data-id="element-282">
            <p className="text-base md:text-lg text-gray-600 font-medium leading-relaxed" data-id="element-283"></p>
            <p className="text-lg md:text-xl font-bold text-gray-900 mt-4 md:mt-6" data-id="element-284">
              No es falta de capacidad.
              <br data-id="element-285" />
              <span className="bg-gradient-to-r from-kid-purple to-kid-pink bg-clip-text text-transparent" data-id="element-286">
                Es falta de un proceso claro.
              </span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}